<template>
  <div>
    <v-card flat>
      <v-card-text class="pa-1">
        <date-search v-if="with_date_search" @onDateSearch="handleDateSearch"></date-search>
        <v-data-table
          :headers="comp_headers"
          :items="loading ? [] : items"
          class="elevation-0"
          :search="tableSearch"
          :loading="loading"
          ref="table"
          mobile-breakpoint="1"
        >
          <template v-slot:top>
            <v-row justify="center" class="mb-2">
              <v-col cols='5'>
                <v-card style="border-radius:12px">
                  <v-card-text class="px-2 py-1">
                    <v-row align="center" class="px-5 py-2" justify="center">
                      <v-icon x-large class="mr-5" color='blue-grey darken-3'>mdi-currency-usd</v-icon>
                      <span class="title">{{ total_checks_sum?.toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'}) || '0.00' }}</span>
                    </v-row>
                  </v-card-text>
                </v-card>
              </v-col>

              <v-col cols='5'>
                <v-card style="border-radius:12px">
                  <v-card-text class="px-2 py-1">
                    <v-row align="center" class="px-5 py-2" justify="center">
                      <v-icon x-large class="mr-5" color='blue-grey darken-3'>mdi-credit-card-outline</v-icon>
                      <span class="title">{{ total_checks }} cheques</span>
                    </v-row>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
          </template>

          <template v-slot:item.attributes.place_name="{item}">
            <span style="text-wrap: nowrap;">
              {{ item.attributes.place_name}}
            </span>
          </template>

          <template v-slot:item.attributes.payed_at="{item}">
            {{ $moment(item.attributes.payed_at.substring(0,10)).format('L') }}
          </template>
          <template v-slot:item.attributes.good_to="{item}">
            {{ $moment(item.attributes.good_to.substring(0,10)).format('L') }}
          </template>

          <template v-slot:item.attributes.value="{item}">
            {{ item.attributes.value.toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'}) }}
          </template>

          <template v-slot:item.attributes.details="{item}">
            <div class="d-flex align-center">
              <DialogOrdersPayedBySource :payment_id="item.attributes.payment_id"></DialogOrdersPayedBySource>
              <DownloadPaymentResume :payment_id="item.attributes.payment_id"></DownloadPaymentResume>
              <v-btn small color="primary" rounded dark @click="showCheck(item)">Detalhes</v-btn>
            </div>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>

    <check-dialog :check="check" :check_dialog="check_dialog" @close="closeDialog" @doneUpdate="handleDoneUpdate" @doneReturned="handleDoneReturned" @updatedCheck="handleUpdatedCheck"></check-dialog>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'ChecksTable',
  props: {
    items: {
      type: Array
    },
    headers: {
      type: Array
    },
    title: {
      type: String
    },
    with_date_search: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    },
    /** Texto vindo do FilterData (filtro na API / busca na tabela). */
    tableSearch: {
      type: String,
      default: ''
    }
  },
  components: {
    CheckDialog: () => import('./CheckDialog'),
    DialogOrdersPayedBySource: () => import("@/_backoffice/_financial/components/payment/shared/DialogOrdersPayedBySource.vue"),
    DateSearch: () => import('@/_backoffice/_financial/components/shared/DateSearch.vue'),
    DownloadPaymentResume: () => import("@/_backoffice/_financial/components/payment/shared/DownloadPaymentResume.vue"),
  },
  data() {
    return {
      headers_default: [
        { text: 'Pago em', value: 'attributes.payed_at', align: 'center' },
        { text: 'Módulo', value: 'attributes.place_name' },
        { text: 'Cliente', value: 'attributes.client_name', align: 'center' },
        { text: 'Valor (R$)', value: 'attributes.value', align: 'center' },
        { text: 'Bom para', value: 'attributes.good_to', align: 'center' },
        { text: 'Num. Cheque', value: 'attributes.check_number', align: 'center' },
        { text: 'Nominal', value: 'attributes.nominal', align: 'center' },
        { text: 'Envelope', value: 'attributes.envelope_name', align: 'center' },
        { text: 'Confirmado por', value: 'attributes.confirmed_by', align: 'center' },
        { text: 'Detalhes', value: 'attributes.details', align: 'center' }
      ],
      check_dialog: false,
      check: {},
      loading_one_check: false,
      total_value_sum: 0,
      total_checks_sum: 0,
    }
  },
  computed: {
    comp_headers(){
      return this.headers || this.headers_default
    },
    table(){
      return this.$refs?.table
    },
    total_checks() {
      if (this.$refs.table && this.tableSearch) {
        return this.$refs.table.internalCurrentItems.length
      }
      return this.items.length
    },
  },
  methods: {
    showCheck(item) {
      this.loading_one_check = true
      this.check_dialog = true
      this.check = null
      this.check = {id: item.id, ...item.attributes}
      this.loading_one_check = false
    },
    closeDialog() {
      this.check_dialog = false
      this.check = null
    },
    handleUpdatedCheck(item){
      let idx = this.items.findIndex(el => el.attributes.id == item.id)
      this.items[idx].attributes.attached_file_url = item.attached_file_url
    },
    handleDateSearch(e){
      this.$emit('dateSearched', e)
    },
    handleDoneUpdate(){
      this.$emit('doneUpdate')
    },
    handleDoneReturned(){
      this.check_dialog = false
      this.$emit('doneReturned')
    },
    updateChecksSum() {
      const table = this.$refs.table
      const items = (this.tableSearch && table?.internalCurrentItems)
        ? table.internalCurrentItems
        : this.items
      this.total_checks_sum = items.reduce(
        (acc, one) => acc + (parseFloat(one.attributes?.value) || 0),
        0
      )
    },
  },
  watch: {
    items: {
      handler() {
        this.$nextTick(() => this.updateChecksSum())
      },
      deep: true,
    },
    tableSearch() {
      this.$nextTick(() => this.updateChecksSum())
    },
    loading() {
      this.$nextTick(() => this.updateChecksSum())
    },
  },
  mounted() {
    this.$nextTick(() => this.updateChecksSum())
  },
}
</script>
